export default "__VITE_ASSET__Bt44jJhU__"